import _slicedToArray from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { fieldIntersection, hash, hasIntersection, isEmpty, keys, some } from '../../util';
import { requiresSelectionId } from '../selection';
import { AggregateNode } from './aggregate';
import { BinNode } from './bin';
import { OutputNode } from './dataflow';
import { FacetNode } from './facet';
import { FilterNode } from './filter';
import { ParseNode } from './formatparse';
import { IdentifierNode } from './identifier';
import { BottomUpOptimizer, isDataSourceNode, Optimizer, TopDownOptimizer } from './optimizer';
import { SourceNode } from './source';
import { TimeUnitNode } from './timeunit';
/**
 * Merge identical nodes at forks by comparing hashes.
 *
 * Does not need to iterate from leaves so we implement this with recursion as it's a bit simpler.
 */

export var MergeIdenticalNodes = /*#__PURE__*/function (_TopDownOptimizer) {
  _inherits(MergeIdenticalNodes, _TopDownOptimizer);

  var _super = _createSuper(MergeIdenticalNodes);

  function MergeIdenticalNodes() {
    _classCallCheck(this, MergeIdenticalNodes);

    return _super.apply(this, arguments);
  }

  _createClass(MergeIdenticalNodes, [{
    key: "mergeNodes",
    value: function mergeNodes(parent, nodes) {
      var mergedNode = nodes.shift();

      var _iterator = _createForOfIteratorHelper(nodes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          parent.removeChild(node);
          node.parent = mergedNode;
          node.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "run",
    value: function run(node) {
      var hashes = node.children.map(function (x) {
        return x.hash();
      });
      var buckets = {};

      for (var i = 0; i < hashes.length; i++) {
        if (buckets[hashes[i]] === undefined) {
          buckets[hashes[i]] = [node.children[i]];
        } else {
          buckets[hashes[i]].push(node.children[i]);
        }
      }

      var _iterator2 = _createForOfIteratorHelper(keys(buckets)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var k = _step2.value;

          if (buckets[k].length > 1) {
            this.setModified();
            this.mergeNodes(node, buckets[k]);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return MergeIdenticalNodes;
}(TopDownOptimizer);
/**
 * Optimizer that removes identifier nodes that are not needed for selections.
 */

export var RemoveUnnecessaryIdentifierNodes = /*#__PURE__*/function (_TopDownOptimizer2) {
  _inherits(RemoveUnnecessaryIdentifierNodes, _TopDownOptimizer2);

  var _super2 = _createSuper(RemoveUnnecessaryIdentifierNodes);

  function RemoveUnnecessaryIdentifierNodes(model) {
    var _this;

    _classCallCheck(this, RemoveUnnecessaryIdentifierNodes);

    _this = _super2.call(this);
    _this.requiresSelectionId = model && requiresSelectionId(model);
    return _this;
  }

  _createClass(RemoveUnnecessaryIdentifierNodes, [{
    key: "run",
    value: function run(node) {
      if (node instanceof IdentifierNode) {
        // Only preserve IdentifierNodes if we have default discrete selections
        // in our model tree, and if the nodes come after tuple producing nodes.
        if (!(this.requiresSelectionId && (isDataSourceNode(node.parent) || node.parent instanceof AggregateNode || node.parent instanceof ParseNode))) {
          this.setModified();
          node.remove();
        }
      }
    }
  }]);

  return RemoveUnnecessaryIdentifierNodes;
}(TopDownOptimizer);
/**
 * Removes duplicate time unit nodes (as determined by the name of the output field) that may be generated due to
 * selections projected over time units. Only keeps the first time unit in any branch.
 *
 * This optimizer is a custom top down optimizer that keep track of produced fields in a branch.
 */

export var RemoveDuplicateTimeUnits = /*#__PURE__*/function (_Optimizer) {
  _inherits(RemoveDuplicateTimeUnits, _Optimizer);

  var _super3 = _createSuper(RemoveDuplicateTimeUnits);

  function RemoveDuplicateTimeUnits() {
    _classCallCheck(this, RemoveDuplicateTimeUnits);

    return _super3.apply(this, arguments);
  }

  _createClass(RemoveDuplicateTimeUnits, [{
    key: "optimize",
    value: function optimize(node) {
      this.run(node, new Set());
      return this.modifiedFlag;
    }
  }, {
    key: "run",
    value: function run(node, timeUnitFields) {
      var producedFields = new Set();

      if (node instanceof TimeUnitNode) {
        producedFields = node.producedFields();

        if (hasIntersection(producedFields, timeUnitFields)) {
          this.setModified();
          node.removeFormulas(timeUnitFields);

          if (node.producedFields.length === 0) {
            node.remove();
          }
        }
      }

      var _iterator3 = _createForOfIteratorHelper(node.children),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          this.run(child, new Set([].concat(_toConsumableArray(timeUnitFields), _toConsumableArray(producedFields))));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);

  return RemoveDuplicateTimeUnits;
}(Optimizer);
/**
 * Remove output nodes that are not required.
 */

export var RemoveUnnecessaryOutputNodes = /*#__PURE__*/function (_TopDownOptimizer3) {
  _inherits(RemoveUnnecessaryOutputNodes, _TopDownOptimizer3);

  var _super4 = _createSuper(RemoveUnnecessaryOutputNodes);

  function RemoveUnnecessaryOutputNodes() {
    _classCallCheck(this, RemoveUnnecessaryOutputNodes);

    return _super4.call(this);
  }

  _createClass(RemoveUnnecessaryOutputNodes, [{
    key: "run",
    value: function run(node) {
      if (node instanceof OutputNode && !node.isRequired()) {
        this.setModified();
        node.remove();
      }
    }
  }]);

  return RemoveUnnecessaryOutputNodes;
}(TopDownOptimizer);
/**
 * Move parse nodes up to forks and merges them if possible.
 */

export var MoveParseUp = /*#__PURE__*/function (_BottomUpOptimizer) {
  _inherits(MoveParseUp, _BottomUpOptimizer);

  var _super5 = _createSuper(MoveParseUp);

  function MoveParseUp() {
    _classCallCheck(this, MoveParseUp);

    return _super5.apply(this, arguments);
  }

  _createClass(MoveParseUp, [{
    key: "run",
    value: function run(node) {
      if (isDataSourceNode(node)) {
        return;
      }

      if (node.numChildren() > 1) {
        // Don't move parse further up but continue with parent.
        return;
      }

      var _iterator4 = _createForOfIteratorHelper(node.children),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;

          if (child instanceof ParseNode) {
            if (node instanceof ParseNode) {
              this.setModified();
              node.merge(child);
            } else {
              // Don't swap with nodes that produce something that the parse node depends on (e.g. lookup).
              if (fieldIntersection(node.producedFields(), child.dependentFields())) {
                continue;
              }

              this.setModified();
              child.swapWithParent();
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return;
    }
  }]);

  return MoveParseUp;
}(BottomUpOptimizer);
/**
 * Inserts an intermediate ParseNode containing all non-conflicting parse fields and removes the empty ParseNodes.
 *
 * We assume that dependent paths that do not have a parse node can be just merged.
 */

export var MergeParse = /*#__PURE__*/function (_BottomUpOptimizer2) {
  _inherits(MergeParse, _BottomUpOptimizer2);

  var _super6 = _createSuper(MergeParse);

  function MergeParse() {
    _classCallCheck(this, MergeParse);

    return _super6.apply(this, arguments);
  }

  _createClass(MergeParse, [{
    key: "run",
    value: function run(node) {
      var originalChildren = _toConsumableArray(node.children);

      var parseChildren = node.children.filter(function (child) {
        return child instanceof ParseNode;
      });

      if (node.numChildren() > 1 && parseChildren.length >= 1) {
        var commonParse = {};
        var conflictingParse = new Set();

        var _iterator5 = _createForOfIteratorHelper(parseChildren),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var parseNode = _step5.value;
            var parse = parseNode.parse;

            var _iterator9 = _createForOfIteratorHelper(keys(parse)),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var k = _step9.value;

                if (!(k in commonParse)) {
                  commonParse[k] = parse[k];
                } else if (commonParse[k] !== parse[k]) {
                  conflictingParse.add(k);
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        var _iterator6 = _createForOfIteratorHelper(conflictingParse),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var field = _step6.value;
            delete commonParse[field];
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        if (!isEmpty(commonParse)) {
          this.setModified();
          var mergedParseNode = new ParseNode(node, commonParse);

          var _iterator7 = _createForOfIteratorHelper(originalChildren),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var childNode = _step7.value;

              if (childNode instanceof ParseNode) {
                var _iterator8 = _createForOfIteratorHelper(keys(commonParse)),
                    _step8;

                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                    var key = _step8.value;
                    delete childNode.parse[key];
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }
              }

              node.removeChild(childNode);
              childNode.parent = mergedParseNode; // remove empty parse nodes

              if (childNode instanceof ParseNode && keys(childNode.parse).length === 0) {
                childNode.remove();
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      }
    }
  }]);

  return MergeParse;
}(BottomUpOptimizer);
/**
 * Repeatedly remove leaf nodes that are not output or facet nodes.
 * The reason is that we don't need subtrees that don't have any output nodes.
 * Facet nodes are needed for the row or column domains.
 */

export var RemoveUnusedSubtrees = /*#__PURE__*/function (_BottomUpOptimizer3) {
  _inherits(RemoveUnusedSubtrees, _BottomUpOptimizer3);

  var _super7 = _createSuper(RemoveUnusedSubtrees);

  function RemoveUnusedSubtrees() {
    _classCallCheck(this, RemoveUnusedSubtrees);

    return _super7.apply(this, arguments);
  }

  _createClass(RemoveUnusedSubtrees, [{
    key: "run",
    value: function run(node) {
      if (node instanceof OutputNode || node.numChildren() > 0 || node instanceof FacetNode) {// no need to continue with parent because it is output node or will have children (there was a fork)
      } else if (node instanceof SourceNode) {// ignore empty unused sources as they will be removed in optimizationDataflowHelper
      } else {
        this.setModified();
        node.remove();
      }
    }
  }]);

  return RemoveUnusedSubtrees;
}(BottomUpOptimizer);
/**
 * Merge adjacent time unit nodes.
 */

export var MergeTimeUnits = /*#__PURE__*/function (_BottomUpOptimizer4) {
  _inherits(MergeTimeUnits, _BottomUpOptimizer4);

  var _super8 = _createSuper(MergeTimeUnits);

  function MergeTimeUnits() {
    _classCallCheck(this, MergeTimeUnits);

    return _super8.apply(this, arguments);
  }

  _createClass(MergeTimeUnits, [{
    key: "run",
    value: function run(node) {
      var timeUnitChildren = node.children.filter(function (x) {
        return x instanceof TimeUnitNode;
      });
      var combination = timeUnitChildren.pop();

      var _iterator10 = _createForOfIteratorHelper(timeUnitChildren),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var timeUnit = _step10.value;
          this.setModified();
          combination.merge(timeUnit);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }]);

  return MergeTimeUnits;
}(BottomUpOptimizer);
export var MergeAggregates = /*#__PURE__*/function (_BottomUpOptimizer5) {
  _inherits(MergeAggregates, _BottomUpOptimizer5);

  var _super9 = _createSuper(MergeAggregates);

  function MergeAggregates() {
    _classCallCheck(this, MergeAggregates);

    return _super9.apply(this, arguments);
  }

  _createClass(MergeAggregates, [{
    key: "run",
    value: function run(node) {
      var aggChildren = node.children.filter(function (child) {
        return child instanceof AggregateNode;
      }); // Object which we'll use to map the fields which an aggregate is grouped by to
      // the set of aggregates with that grouping. This is useful as only aggregates
      // with the same group by can be merged

      var groupedAggregates = {}; // Build groupedAggregates

      var _iterator11 = _createForOfIteratorHelper(aggChildren),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var agg = _step11.value;
          var groupBys = hash(agg.groupBy);

          if (!(groupBys in groupedAggregates)) {
            groupedAggregates[groupBys] = [];
          }

          groupedAggregates[groupBys].push(agg);
        } // Merge aggregateNodes with same key in groupedAggregates

      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      var _iterator12 = _createForOfIteratorHelper(keys(groupedAggregates)),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var group = _step12.value;
          var mergeableAggs = groupedAggregates[group];

          if (mergeableAggs.length > 1) {
            var mergedAggs = mergeableAggs.pop();

            var _iterator13 = _createForOfIteratorHelper(mergeableAggs),
                _step13;

            try {
              for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                var _agg = _step13.value;

                if (mergedAggs.merge(_agg)) {
                  node.removeChild(_agg);
                  _agg.parent = mergedAggs;

                  _agg.remove();

                  this.setModified();
                }
              }
            } catch (err) {
              _iterator13.e(err);
            } finally {
              _iterator13.f();
            }
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }]);

  return MergeAggregates;
}(BottomUpOptimizer);
/**
 * Merge bin nodes and move them up through forks. Stop at filters, parse, identifier as we want them to stay before the bin node.
 */

export var MergeBins = /*#__PURE__*/function (_BottomUpOptimizer6) {
  _inherits(MergeBins, _BottomUpOptimizer6);

  var _super10 = _createSuper(MergeBins);

  function MergeBins(model) {
    var _this2;

    _classCallCheck(this, MergeBins);

    _this2 = _super10.call(this);
    _this2.model = model;
    return _this2;
  }

  _createClass(MergeBins, [{
    key: "run",
    value: function run(node) {
      var moveBinsUp = !(isDataSourceNode(node) || node instanceof FilterNode || node instanceof ParseNode || node instanceof IdentifierNode);
      var promotableBins = [];
      var remainingBins = [];

      var _iterator14 = _createForOfIteratorHelper(node.children),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var child = _step14.value;

          if (child instanceof BinNode) {
            if (moveBinsUp && !fieldIntersection(node.producedFields(), child.dependentFields())) {
              promotableBins.push(child);
            } else {
              remainingBins.push(child);
            }
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      if (promotableBins.length > 0) {
        var promotedBin = promotableBins.pop();

        var _iterator15 = _createForOfIteratorHelper(promotableBins),
            _step15;

        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var bin = _step15.value;
            promotedBin.merge(bin, this.model.renameSignal.bind(this.model));
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }

        this.setModified();

        if (node instanceof BinNode) {
          node.merge(promotedBin, this.model.renameSignal.bind(this.model));
        } else {
          promotedBin.swapWithParent();
        }
      }

      if (remainingBins.length > 1) {
        var remainingBin = remainingBins.pop();

        var _iterator16 = _createForOfIteratorHelper(remainingBins),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var _bin = _step16.value;
            remainingBin.merge(_bin, this.model.renameSignal.bind(this.model));
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }

        this.setModified();
      }
    }
  }]);

  return MergeBins;
}(BottomUpOptimizer);
/**
 * This optimizer takes output nodes that are at a fork and moves them before the fork.
 *
 * The algorithm iterates over the children and tries to find the last output node in a chain of output nodes.
 * It then moves all output nodes before that main output node. All other children (and the children of the output nodes)
 * are inserted after the main output node.
 */

export var MergeOutputs = /*#__PURE__*/function (_BottomUpOptimizer7) {
  _inherits(MergeOutputs, _BottomUpOptimizer7);

  var _super11 = _createSuper(MergeOutputs);

  function MergeOutputs() {
    _classCallCheck(this, MergeOutputs);

    return _super11.apply(this, arguments);
  }

  _createClass(MergeOutputs, [{
    key: "run",
    value: function run(node) {
      var children = _toConsumableArray(node.children);

      var hasOutputChild = some(children, function (child) {
        return child instanceof OutputNode;
      });

      if (!hasOutputChild || node.numChildren() <= 1) {
        return;
      }

      var otherChildren = []; // The output node we will connect all other nodes to.
      // Output nodes will be added before the new node, other nodes after.

      var mainOutput;

      var _iterator17 = _createForOfIteratorHelper(children),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _child = _step17.value;

          if (_child instanceof OutputNode) {
            var lastOutput = _child;

            while (lastOutput.numChildren() === 1) {
              var _lastOutput$children = _slicedToArray(lastOutput.children, 1),
                  theChild = _lastOutput$children[0];

              if (theChild instanceof OutputNode) {
                lastOutput = theChild;
              } else {
                break;
              }
            }

            otherChildren.push.apply(otherChildren, _toConsumableArray(lastOutput.children));

            if (mainOutput) {
              // Move the output nodes before the mainOutput. We do this by setting
              // the parent of the first not to the parent of the main output and
              // the main output's parent to the last output.
              // note: the child is the first output
              node.removeChild(_child);
              _child.parent = mainOutput.parent;
              mainOutput.parent.removeChild(mainOutput);
              mainOutput.parent = lastOutput;
              this.setModified();
            } else {
              mainOutput = lastOutput;
            }
          } else {
            otherChildren.push(_child);
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      if (otherChildren.length) {
        this.setModified();

        var _iterator18 = _createForOfIteratorHelper(otherChildren),
            _step18;

        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var child = _step18.value;
            child.parent.removeChild(child);
            child.parent = mainOutput;
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
      }
    }
  }]);

  return MergeOutputs;
}(BottomUpOptimizer);